import cn from 'classnames';
import { useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { shopCantEditEmailAndPhoneNotify } from '@pages/personal/client/editor-page/Modals/helpers.ts';
import { useAppDispatch, useUser } from '@shared/hooks/index.ts';
import { Card, TextInput } from '@shared/ui';
import { getErrorMessages } from '@src/library/helpers/events/errorMessages';
import type { IClientForm } from '../../model';
import * as st from './styles.module.scss';

type Props = {
  disabled?: boolean;
  isLoading?: boolean;
  setEmailVerified?: (isEmailVerified: boolean) => void;
  isEditable?: boolean;
};

export const Email: React.FC<Props> = ({
  disabled,
  isLoading,
  setEmailVerified,
  isEditable = true,
}): JSX.Element => {
  const {
    register,
    control,
    formState: { errors },
    setValue,
  } = useFormContext();
  const dispatch = useAppDispatch();
  const emailValue: string = useWatch({ name: 'email', control });
  const { user } = useUser();

  useEffect(() => {
    setEmailVerified && setEmailVerified(user?.email === emailValue);
  }, [user, emailValue, setEmailVerified]);

  const errorMessage = getErrorMessages(errors, ['email']);

  const localFormSave: IClientForm | null = JSON.parse(
    localStorage.getItem('clientEditorFormState')!
  );

  useEffect(() => {
    if (localFormSave !== null && localFormSave.email !== '')
      setValue('email', localFormSave.email, { shouldValidate: true, shouldDirty: true });
  }, []);
  return (
    <>
      <fieldset className={st.main}>
        <div className={st.main__header}>
          <h3>E-MAIL</h3>
          <p>{errorMessage}</p>
        </div>
        <div className={st.blocks}>
          <Card className={st.contact}>
            <div className={st.wrapper}>
              <div className={cn(st.email, (disabled || isLoading) && st.disabled)}>
                <Controller
                  name={'email'}
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextInput
                      onClick={(event) => {
                        !isEditable &&
                          dispatch(shopCantEditEmailAndPhoneNotify()) &&
                          event.currentTarget.blur();
                      }}
                      disabled={disabled || isLoading}
                      value={value}
                      label=""
                      fullWidth
                      {...register(`email`)}
                      onChange={(e) => {
                        isEditable && setEmailVerified && setEmailVerified(false);
                        isEditable && onChange(e.target.value);
                      }}
                      isValid={!!errors['email']}
                    />
                  )}
                />
              </div>
            </div>
          </Card>
        </div>
      </fieldset>
    </>
  );
};
